import { useEffect, useRef } from "react";
import { useThree } from "@react-three/fiber";
import { useSceneStore } from "@/state/useSceneStore";
import { useCameraTo } from "@/scene/cameras/useCameraTo";

export const CameraDriver = (): null => {
  const pendingCameraMove = useSceneStore((s) => s.pendingCameraMove);
  const cameraTo = useCameraTo();
  const lastId = useRef<number | null>(null);
  const camera = useThree((s) => s.camera);

  useEffect(() => {
    if (import.meta.env.DEV && typeof window !== "undefined") {
      (window as Window & { __camera?: unknown }).__camera = camera;
    }
  }, [camera]);

  useEffect(() => {
    if (!pendingCameraMove) return;
    if (pendingCameraMove.id === lastId.current) return;
    lastId.current = pendingCameraMove.id;
    void cameraTo(pendingCameraMove.pose, pendingCameraMove.duration);
  }, [pendingCameraMove, cameraTo]);

  return null;
};
